import React from 'react';
import { string, oneOf } from 'prop-types';

import { ImpressionProvider } from '@thd-olt-component-react/impression';

import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { CategoryProducts } from '../CategoryProducts/CategoryProducts';
import { ProductRowPlaceholder } from '../ProductPodPlaceholders/ProductRowPlaceholder';

const SpecialBuyCarousel = ({ entryId, specialBuyType }) => {
  const { categories, selectedCategory, isSpecialBuyDataLoading } = useSpecialBuy();

  const impressionData = {
    id: entryId,
    name: specialBuyType === 'sbotd' ? 'SBOTD' : 'SBOTW',
    component: 'SpecialBuyBanner',
    type: 'product',
    position: '',
    category: selectedCategory?.categoryId || ''
  };

  return (
    !categories?.length && isSpecialBuyDataLoading ? (
      <ProductRowPlaceholder />
    ) : (
      <ImpressionProvider data={impressionData}>
        <>
          {categories.map((category) => (
            <CategoryProducts category={category} key={category.categoryId} />
          ))}
        </>
      </ImpressionProvider>
    ));
};

SpecialBuyCarousel.displayName = 'SpecialBuyCarousel';

SpecialBuyCarousel.propTypes = {
  entryId: string,
  specialBuyType: oneOf(['sbotd', 'pro']).isRequired
};

SpecialBuyCarousel.defaultProps = {
  entryId: ''
};

export { SpecialBuyCarousel };
